import React from 'react';
import "./TitleDescription.css"

export default function TitleDescription({title,description,classname,classname2, titleClass}) {
  return (
    <div className={`titleDescriptionContainer text-center  mx-0 ${classname}`} >
        <h2 className={`container-title ${titleClass}`}>{title}</h2>
        <p className={`container-para ${classname2}`}>{description}</p>
    </div>
  )
}

